import {
  NTA_INSTRUCTIONS_INTRO,
  NTA_LANGUAGE_NOTE,
  NTA_TNC_TEXT
} from '../constants';
import {
  NTA_ANSWERING_CHANGE,
  NTA_ANSWERING_INTRO,
  NTA_ANSWERING_SUB_ITEMS,
  NTA_GENERAL_INSTRUCTIONS,
  NTA_INSTRUCTION_SECTIONS,
  NTA_QUESTION_NAV_INTRO,
  NTA_QUESTION_NAV_ITEMS,
  NTA_SECTION_NAV_INSTRUCTIONS
} from './ntaInstructionsContent';

export const NTA_STRUCTURED_MARKER = '__NTA_STRUCTURED_V1__';
export const NTA_STRUCTURED_TYPE = 'nta-structured';

export const NTA_ITEM_TYPE = {
  TEXT: 'text',
  PALETTE_LEGEND: 'palette_legend',
  SCROLL_ARROWS: 'scroll_arrows',
  TEXT_WITH_SUBSTEPS: 'text_with_substeps'
};

export const getDefaultNtaStructuredPayload = () => ({
  version: 1,
  type: NTA_STRUCTURED_TYPE,
  intro: NTA_INSTRUCTIONS_INTRO,
  languageNote: NTA_LANGUAGE_NOTE,
  tncText: NTA_TNC_TEXT,
  sections: [
    {
      id: 'general',
      title: NTA_INSTRUCTION_SECTIONS.GENERAL,
      items: [
        {
          id: 'g1',
          type: NTA_ITEM_TYPE.TEXT,
          text: NTA_GENERAL_INSTRUCTIONS[0]
        },
        {
          id: 'g2',
          type: NTA_ITEM_TYPE.TEXT,
          text: NTA_GENERAL_INSTRUCTIONS[1]
        },
        {
          id: 'g3',
          type: NTA_ITEM_TYPE.PALETTE_LEGEND
        },
        {
          id: 'g4',
          type: NTA_ITEM_TYPE.TEXT,
          text: NTA_GENERAL_INSTRUCTIONS[3]
        },
        {
          id: 'g5',
          type: NTA_ITEM_TYPE.TEXT,
          text: NTA_GENERAL_INSTRUCTIONS[4]
        },
        {
          id: 'g6',
          type: NTA_ITEM_TYPE.SCROLL_ARROWS
        }
      ]
    },
    {
      id: 'question_nav',
      title: NTA_INSTRUCTION_SECTIONS.QUESTION_NAV,
      items: [
        {
          id: 'qn1',
          type: NTA_ITEM_TYPE.TEXT_WITH_SUBSTEPS,
          text: NTA_QUESTION_NAV_INTRO,
          substeps: [...NTA_QUESTION_NAV_ITEMS]
        }
      ]
    },
    {
      id: 'answering',
      title: NTA_INSTRUCTION_SECTIONS.ANSWERING,
      items: [
        {
          id: 'a1',
          type: NTA_ITEM_TYPE.TEXT_WITH_SUBSTEPS,
          text: NTA_ANSWERING_INTRO,
          substeps: [...NTA_ANSWERING_SUB_ITEMS]
        },
        {
          id: 'a2',
          type: NTA_ITEM_TYPE.TEXT,
          text: NTA_ANSWERING_CHANGE
        }
      ]
    },
    {
      id: 'section_nav',
      title: NTA_INSTRUCTION_SECTIONS.SECTION_NAV,
      items: NTA_SECTION_NAV_INSTRUCTIONS.map((text, index) => ({
        id: `s${index + 1}`,
        type: NTA_ITEM_TYPE.TEXT,
        text
      }))
    }
  ]
});

export const serializeNtaStructuredPayload = (payload) =>
  `${NTA_STRUCTURED_MARKER}${JSON.stringify(payload)}`;

const decodeBasicEntities = (raw) =>
  raw
    .replace(/&quot;/g, '"')
    .replace(/&#34;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&apos;/g, "'")
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&nbsp;/g, ' ');

const extractBalancedJsonObject = (text) => {
  const start = text.indexOf('{');
  if (start === -1) return null;

  let depth = 0;
  let inString = false;
  let escaping = false;

  for (let i = start; i < text.length; i += 1) {
    const char = text[i];

    if (inString) {
      if (escaping) {
        escaping = false;
      } else if (char === '\\') {
        escaping = true;
      } else if (char === '"') {
        inString = false;
      }
    } else if (char === '"') {
      inString = true;
    } else if (char === '{') {
      depth += 1;
    } else if (char === '}') {
      depth -= 1;
      if (depth === 0) {
        return text.slice(start, i + 1);
      }
    }
  }

  return null;
};

export const parseNtaStructuredPayload = (raw) => {
  if (!raw || typeof raw !== 'string') return null;

  const text = decodeBasicEntities(raw);
  const markerIndex = text.indexOf(NTA_STRUCTURED_MARKER);
  if (markerIndex === -1) return null;

  const jsonString = extractBalancedJsonObject(
    text.slice(markerIndex + NTA_STRUCTURED_MARKER.length)
  );
  if (!jsonString) return null;

  try {
    const parsed = JSON.parse(jsonString);
    if (parsed?.type !== NTA_STRUCTURED_TYPE) return null;

    if (Array.isArray(parsed.sections)) {
      return parsed;
    }
  } catch (e) {
    return null;
  }

  return null;
};

export const hasNtaStructuredMarker = (raw) =>
  typeof raw === 'string' && raw.includes(NTA_STRUCTURED_MARKER);

export const isNtaStructuredInstructions = (raw) =>
  Boolean(parseNtaStructuredPayload(raw));
